module.exports = __webpack_public_path__ + "static/media/img_dog_salsicha.48219741.svg";